import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=572a3e40&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572a3e40')) {
      api.createRecord('572a3e40', component.options)
    } else {
      api.reload('572a3e40', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=572a3e40&", function () {
      api.rerender('572a3e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SllLMzvNKvyb/JS/videoIframe.vue"
export default component.exports